module.exports = __webpack_public_path__ + "static/process-851973adb032c7017e9f4258e2328ea2.png";